import { useEffect } from "react";

export default function useInstallationEditFormFetchData(
  sitesList,
  getSitesList,
  clientsList,
  getClientsList,
  nomenclaturesList,
  getNomenclatures
) {
  useEffect(() => {
    if (!sitesList || sitesList.length === 0) getSitesList();
  }, [sitesList, getSitesList]);

  useEffect(() => {
    if (!clientsList || clientsList.length === 0) getClientsList();
  }, [clientsList, getClientsList]);

  useEffect(() => {
    if (!nomenclaturesList || nomenclaturesList.length === 0)
      getNomenclatures();
  }, [nomenclaturesList, getNomenclatures]);
}
